import request from '@/utils/request.js'

export function getList (params) {
  return request({
    url: '/virtual/getDealerStorage',
    method: 'get',
    params
  })
}

// 获取库存
export function getDealerStorageCount (params) {
  return request({
    url: '/virtual/getDealerStorageCount',
    method: 'get',
    params
  })
}

// 获取经销商信息
export function getAutelInfo (params) {
  return request({
    url: '/virtual/getAutelInfo',
    method: 'get',
    params
  })
}

// 下载至本地
export function sendDelivery (data) {
  return request({
    url: '/virtual/sendDelivery',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 获取发货记录
export function getDealerDeliveryRecord (data) {
  return request({
    url: '/virtual/getDealerDeliveryRecord',
    method: 'post',
    data
  })
}
